import { Content, Portal as RadixPortal } from "@radix-ui/react-dropdown-menu";
import TimeEntryItem from "app/containers/Features/components/EffortActual/TimeEntryItem";
import { PopupHeader } from "app/containers/Features/components/TimeTracker/PopupHeader";
import { ticketDetailsLocales } from "app/containers/Features/containers/Ticket/locales";
import { IEffortActual } from "app/containers/Features/containers/Ticket/types";
import {
  ISelectedTicketDetails,
  ITimeTrackerForm,
} from "app/containers/Features/containers/TimeSheet/types";
import { TotalEffortType } from "app/types";
import React, { FC } from "react";
import UserTimeInputCard from "./UserTimeInputCard";

export const Portal: FC<{
  isAssignee?: boolean;
  totalEffortActual: TotalEffortType;
  effortActual: IEffortActual[];
  selectedTicketDetails: ISelectedTicketDetails;
  assigneeId?: string;
  hideTimerStartIcon?: boolean;
  contentProps?: React.ComponentProps<typeof Content>;
  callback?: (data: {
    form: ITimeTrackerForm;
    response: IEffortActual;
  }) => void;
}> = ({
  isAssignee,
  totalEffortActual,
  effortActual,
  selectedTicketDetails,
  assigneeId,
  contentProps,
  callback,
  hideTimerStartIcon,
}) => {
  return (
    <RadixPortal>
      <Content
        align="start"
        sideOffset={2}
        className="min-w-[378px] w-[420px] max-w-[420px] bg-white rounded border border-gray-100 shadow-md py-2.5 z-50 max-h-[574px] overflow-y-auto"
        {...contentProps}
      >
        <PopupHeader totalEffortActual={totalEffortActual} />

        <div className="w-full h-px bg-gray-100" />

        {isAssignee ? (
          <UserTimeInputCard
            selectedTicketDetail={selectedTicketDetails}
            assigneeId={assigneeId}
            callback={callback}
            hideTimerStartIcon={hideTimerStartIcon}
          />
        ) : null}

        {effortActual?.length ? (
          <>
            <p className="p-4 leading-none text-sm font-medium">
              {ticketDetailsLocales.timeEntries}
            </p>

            <TimeEntryItem
              effortActual={effortActual}
              selectedTicketDetails={selectedTicketDetails}
            />
          </>
        ) : null}
      </Content>
    </RadixPortal>
  );
};
